var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirstLast({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.70706 0.292847L0.292847 1.70706L5.58574 6.99995L0.292847 12.2928L1.70706 13.7071L8.41417 6.99995L1.70706 0.292847ZM6.70706 0.292847L5.29285 1.70706L10.5857 6.99995L5.29285 12.2928L6.70706 13.7071L13.4142 6.99995L6.70706 0.292847Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstLast);
export default __webpack_public_path__ + "static/media/first-last.9932c029ff07888874552d3204acb1e3.svg";
export { ForwardRef as ReactComponent };